'use strict';
import {getCollection, getDomainClass, getId} from '../../core-utilities/domain/ReduxUtils';


DataTagMixin.$inject = [
  '$miscUtils',
  '$filter',
  'DataTagMixinFilter',
];

// Implement editing managers for each data tag loaded and provide 1 toggle and save for all
export function DataTagMixin($miscUtils, $filter, DataTagMixinFilter) {
  return function dataTagMixin(vm, scope) {
    const filter = DataTagMixinFilter(vm, scope);
    let working = false;

    $miscUtils.bindToExit(scope, isDirty);

    return {
      bindTags: bindTags,
      destroy: cleanup,
      isEditMode: isEditMode,
      isWorking: isWorking,
      getMode: getMode,
      setEditMode: setEditMode,
      setViewMode: setViewMode,
      validate: validate,
      save: $miscUtils.blockPromise(save),
      revert: revert,
      getTagCount: getTagCount,
    };

    function getTagCount() {
      return filter.size('dataTagList');
    }

    function cleanup() {
      filter.destroyFiltering();
      vm.formApis = {};
    }

    function bindTags(taggable) {
      cleanup();
      const domainClass = getDomainClass(getCollection(taggable));
      filter.initFiltering(domainClass.$getDataTagsRelations(getId(taggable)));
    }

    // Update API

    function isEditMode() {
      const id = _getFirstFormId();
      if (id) {
        return vm.formApis[id].isEditMode();
      }
    }

    function isWorking() {
      return working;
    }

    function getMode() {
      const id = _getFirstFormId();
      if (id) {
        return vm.formApis[id].getMode();
      }
    }

    function setViewMode() {
      return _formActionAll('setMode', ['response-view']);
    }

    function setEditMode() {
      return _formActionAll('setMode', ['response-edit']);
    }

    function isDirty() {
      if (!isEditMode()) {
        return false;
      } else {
        const results = $filter.toArray(_formActionAll('isDirty'));
        return results.reduce(function (prev, result) {
          return prev || result;
        }, false);
      }
    }

    function validate() {
      const results = $filter.toArray(_formActionAll('validate'));
      return results.reduce(function (prev, result) {
        return prev && result;
      }, true);
    }

    function save() {
      working = true;
      const promise = Promise.props(_formActionAll('save')).then(() => {
        setViewMode();
      });
      promise.finally(() => {
        working = false;
      });
      return promise;
    }

    function revert() {
      return Promise.props(_formActionAll('revert')).then(function () {
        setViewMode();
      });
    }

    function _formActionAll(name, args) {
      // console.log('_formActionAll name: ' + name, args, vm.formApis);
      const results = {};
      for (const id in vm.formApis) {
        if (vm.formApis.hasOwnProperty(id)) {
          // console.log('_formActionAll ' + id + ' name: ' + name, vm.formApis[id]);
          results[id] = vm.formApis[id][name].apply(vm.formApis[id], args);
        }
      }
      return results;
    }

    function _getFirstFormId() {
      for (const id in vm.formApis) {
        if (vm.formApis.hasOwnProperty(id)) {
          return id;
        }
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/js/data-tags/services/DataTagMixin.js